import { UiBreadcrumbItem, UiPageChromeConfig } from '@system-dyg/shared/ui';

const DEMO_DATABASE_CRUMBS: readonly UiBreadcrumbItem[] = [
  { id: 'admin', label: 'Configuraciones' },
  { id: 'documentation', label: 'Documentación' },
  { id: 'database', label: 'Base de datos' },
  { id: 'demo', label: 'Demo' },
];

export function demoDatabaseChrome(
  title: string,
  ...extra: readonly UiBreadcrumbItem[]
): UiPageChromeConfig {
  return {
    moduleId: 'documentation',
    activeMenubarId: 'doc-database-demo',
    title,
    titleBarMode: 'data-table',
    breadcrumbItems: [...DEMO_DATABASE_CRUMBS, ...extra],
  };
}

export function demoTableSectionChrome(
  tableName: string,
  section: 'Estructura' | 'Contenido',
): UiPageChromeConfig {
  const sectionId = section === 'Estructura' ? 'structure' : 'content';
  return demoDatabaseChrome(
    `${section} · ${tableName}`,
    { id: 'tables', label: 'Tablas' },
    { id: 'table', label: tableName },
    { id: sectionId, label: section },
  );
}
